import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FormInput = ({
  type,
  id,
  placeholder,
  icon,
  hint = "",
  label,
  value,
  setValue,
  disabled,
}) => {
  return (
    <div className="form-floating mb-3">
      <input
        type={type}
        className="form-control"
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
      />
      <label htmlFor={id}>
        <FontAwesomeIcon icon={icon} /> {label}
      </label>
      {hint && (
        <div
          className="d-flex justify-content-end text-muted"
          style={{ fontSize: 12 }}
        >
          {hint}
        </div>
      )}
    </div>
  );
};

export default FormInput;
